import { client } from "../../client";

export type Customer = {
  id: string;
  number: string | null;
  customerType: string;
  customerClass: string;
  name: string;
  forename: string | null;
  surname: string | null;
  companyName: string | null;
  companyNo: string | null;
  status: string;
  hasPriorityServices: boolean;
  hasVulnerabilities: boolean;
  numberOfAccounts: string;
};

export const getAccountCustomer = (queryKey: string, accountNumber: string) => {
  return client
    .get<Customer>(`accounts/${accountNumber}/customer`)
    .then((response) => response?.data);
};
